import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid, Image} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useApplicationScreenshot} from '../hooks/useApplicationScreenshot.ts';
import {useApplicationScreenshotsSelection} from '../hooks/useApplicationScreenshotsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: screenshotId} = useParams();

    if (typeof screenshotId === 'undefined') {
        throw new Error('screenshotId is required parameter');
    }

    const {
        record: screenshot,
    } = useApplicationScreenshot(screenshotId);

    const {handleClearSelection} = useApplicationScreenshotsSelection();

    const {
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);


    if (!screenshot) {
        return <PlatformLoader message='Loading screenshot...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={screenshot.url ? `${screenshot.url}${screenshot.path ? '/' + screenshot.path : ''}` : screenshot.id}
            pageNavigation={<EditPageNavigation component={screenshot}/>}
            tools={tools}
        >

            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 4
                }}>
                    <Profile
                        record={screenshot}
                    />
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    lg: 8
                }}>
                    {screenshot.screenshotUrl && screenshot.status === 'COMPLETED' && (
                        <Image
                            src={screenshot.screenshotUrl}
                            alt="Screenshot preview"
                            radius="md"
                        />
                    )}
                </Grid.Col>
            </Grid>

        </FormPageLayout>
    );
};
